import qs from 'qs'
import { ajax } from 'zn-common'

interface IData {
  [key: string]: any
}

export interface IResultData<T = any> {
  data: T
  code: string
  message: string
  error?: number
  url?: string
}

interface IFetchOption {
  trimParams?: boolean
  noClean?: boolean
  // 请求前缀
  prefix?: string,
  successCode?: number | string,
  dataType?: any
}

// interface IPageData {
//   pageNo: number
//   pageSize: number
//   total: number
//   data: any
// }

/**
 * 发送POST请求
 * @param path
 * @param data
 * @param prefix
 */
 
export const postForm = async (path, data: IData, { dataType = 'json' }: IFetchOption = {}): Promise<any> => {
  const res = await ajax(
    {
      url: path,
      method: 'POST',
      data: qs.stringify(data, { indices: false }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      dataType,
    },
  )
  delete res._failure
  return res
}
